import { useNavigate, useLocation, type NavigateFunction } from "react-router-dom";
import { useRoutes } from "react-router-dom";
import { useEffect, useRef } from "react";
import routes from "./config";

let navigateResolver: (navigate: ReturnType<typeof useNavigate>) => void;

declare global {
  interface Window {
    REACT_APP_NAVIGATE: ReturnType<typeof useNavigate>;
  }
}

export const navigatePromise = new Promise<NavigateFunction>((resolve) => {
  navigateResolver = resolve;
});

export function AppRoutes() {
  const element = useRoutes(routes);
  const navigate = useNavigate();
  const location = useLocation();
  const prevPathname = useRef(location.pathname);

  useEffect(() => {
    window.REACT_APP_NAVIGATE = navigate;
    navigateResolver(window.REACT_APP_NAVIGATE);
  });

  // Scroll to top when navigating to a new page (not on hash changes)
  useEffect(() => {
    if (location.pathname !== prevPathname.current && !location.hash) {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    }
    prevPathname.current = location.pathname;
  }, [location.pathname, location.hash]);

  return element;
}
